const link_regular =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

export const openURL = () => {
    const link = document.getElementById("agreement_url").value;

    let is_valid = link.match(link_regular);

    if (is_valid !== null) {
        window.open(
            link,
            '_blank'
          );
    }
};

if (document.getElementById("open-agreement-url")) {
    document
        .getElementById("open-agreement-url")
        .addEventListener("click", () => openURL());
}

if (document.getElementById("agreement_url")) {
    function toggle_redirect_btn(input_value) {
        if (input_value && input_value.match(link_regular)) {
            document.getElementById("open-agreement-url").style =
                "display: inline-block";
        } else {
            document.getElementById("open-agreement-url").style =
                "display: none";
        }
    }

    document.getElementById("agreement_url").addEventListener("input", (e) => {
        toggle_redirect_btn(e.target.value);
    });

    if (!document.getElementById("agreement_url").value) {
        document.getElementById("open-agreement-url").style = "display: none";
    }
}
